import { catchAxiosError } from 'utilities/axios';
import axiosInstance from 'api-services/api-client';

export const getAllConversations = async (chatbotId, offset) => {
  return catchAxiosError(
    axiosInstance
      .get(`/admin/list-conversations/${chatbotId}`, {
        params: { offset },
      })
      .then((response) => {
        return response;
      })
      .catch((err) => {
        return err;
      }),
  );
};

export const getUserChats = async (conversationId) => {
  return catchAxiosError(
    axiosInstance
      .get(`/admin/conversation-messages/${conversationId}`)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        return err;
      }),
  );
};
